<template>
  <div>
    <div class="row" style>
      <div class="col-sm">
        <h1>Waist measurements</h1>
      </div>
      <div class="col-sm">
        <button
          id="measurement-create-button"
          class="btn btn-primary float-sm-right"
          v-on:click="moveToWaistCreateView()"
        >+ New measurement</button>
      </div>
    </div>

    <div class="row" style="align-items: center;" v-if="store.getWaistMeasurementCount() > 0">
      <div class="col-sm">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              role="button"
              class="nav-link"
              v-bind:class="{active: selectedView == 'list'}"
              v-on:click="$router.push({ name: 'waist.list'})"
            >List</a>
          </li>
          <li class="nav-item">
            <a
              role="button"
              class="nav-link"
              v-bind:class="{active: selectedView == 'chart'}"
              v-on:click="$router.push({ name: 'waist.chart'})"
            >Chart</a>
          </li>
          <!-- <li class="nav-item">
            <a role="button" class="nav-link" v-bind:class="{active: selectedView == 'Table'}" v-on:click="selectedView = 'Table'">Table</a>
          </li>-->
        </ul>
      </div>
    </div>

    <div id="waist-main-content" v-if="store.getWaistMeasurementCount() > 0">
      <waist-list v-if="selectedView == 'list'" />
      <measurement-chart
        :measurements="store.state.waistMeasurements"
        measurementName="Waist circumference"
        measurementUnit="cm"
        :measurementDivider="10"
        measurementProperty="measurement"
        color="rgb(255, 99, 132)"
        v-if="selectedView == 'chart'"
      />
    </div>

    <div
      id="waist-measurement-info"
      v-if="store.getWaistMeasurementCount() == 0"
    >This page is all about waist measurements.</div>
    <div id="no-waist-measurements-info" v-if="store.getWaistMeasurementCount() == 0">
      <p>
        However, you have no waist measurements yet.
        <br />You can add the first one right now.
      </p>
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import WaistList from "@/components/WaistList.vue";
import MeasurementChart from "@/components/MeasurementChart.vue";

export default {
  name: "WaistMeasurementView",
  components: {
    WaistList,
    MeasurementChart
  },
  data: function() {
    return {
      store: store,
    };
  },
  computed: {
    selectedView: function() {
      if (this.$route.name === "waist.chart")
        return "chart";

      return "list";
    }
  },
  created: function() {},
  mounted: function() {},
  methods: {
    selectTab(tab) {
      this.store.state.waistView.selectedView = tab;
    },
    moveToWaistCreateView() {
      this.store.state.waistView.cancelRoute = "waist";
      this.$router.push({
        name: 'waist.create'
      });
    }
  }
};
</script>

<style scoped>
#waist-measurement-info {
  font-size: 200%;
  color: #111;
}

#no-waist-measurements-info {
  font-size: 145%;
  color: #333;
}

.main-content-row {
  padding-top: 1rem;
}

.nav-tabs {
  margin-top: 1em;
}

.nav-tabs .nav-link {
  color: gray;
  cursor: pointer;
}
</style>